// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610141806/js/" + chunkId + "." + {"44":"24dd5ef6","225":"df5f88f3","481":"6af83cdc","486":"24ba5f37","770":"e41206cc"}[chunkId] + ".0.7131082683581972.chunk.js";
};